import Vue from 'vue'
import { get, intersection, omit } from 'lodash'

export class Security {
  constructor(router) {
    this.router = router
    this.vm = new Vue({
      data: { user: null }
    })
  }

  getUserRoleByCode(code) {
    const roles = get(this, 'vm.user.user_roles', [])
    return roles.find(r => r.role_code === code)
  }

  get() {
    if (null === this.vm.user) {
      throw new Error('Attempt to access user before being set')
    }

    return this.vm.user
  }

  set(user) {
    if (null === user) {
      throw new Error('Attempt to set nullable user')
    }

    user = omit(user, ['client', 'manager'])

    this.vm.user = Object.assign({}, user, {
      roles: user.user_roles.map(x => {
        return x.role_code
      })
    })
  }

  unset() {
    this.vm.user = null
  }

  hasAccess(route) {
    if (route) {
      return this.hasAccessToRoute(route).access
    }

    return false
  }

  hasRoles(roles) {
    if (null === this.vm.user) return false
    return !!intersection(this.vm.user.roles, roles).length
  }

  hasAccessToRoute(route) {
    let matchedRoute =
      void 0 !== route.matched ? route.matched.find(x => x.meta.roles) : route

    let routeRoles = get(matchedRoute, 'meta.roles', false)

    if (null !== this.vm.user && routeRoles) {
      if (!this.hasRoles(routeRoles, this.vm.user.roles)) {
        return {
          access: false,
          redirect: '403'
        }
      }
    } else if (routeRoles) {
      return {
        access: false,
        redirect: 'Auth.Login'
      }
    }

    return { access: true }
  }

  resolve(to, from, next) {
    let { access, redirect } = this.hasAccessToRoute(to)
    access ? next() : next({ name: redirect })
  }
}
